import React from 'react';
import { Link } from 'react-router-dom';
import SectorPage from '../components/SectorPage';
import Ticker from '../components/Ticker';

const SERIF = "'Newsreader', Georgia, serif";
const TEAL  = '#1d6f6a';
const SELF  = '/coverage/technology-ai';

function SponsoredBand() {
  return (
    <div style={{ background: '#0d2235', marginTop: 34, position: 'relative', overflow: 'hidden' }} data-testid="tai-sponsored-band">
      <svg preserveAspectRatio="xMidYMid slice" viewBox="0 0 1200 100" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0.07, pointerEvents: 'none' }} aria-hidden="true">
        <circle cx="100" cy="30" r="3" fill="#fff"/><circle cx="260" cy="70" r="3" fill="#fff"/><circle cx="420" cy="25" r="3" fill="#fff"/>
        <circle cx="580" cy="65" r="3" fill="#fff"/><circle cx="740" cy="35" r="3" fill="#fff"/><circle cx="900" cy="72" r="3" fill="#fff"/>
        <circle cx="1060" cy="28" r="3" fill="#fff"/>
        <g stroke="#fff" strokeWidth=".8">
          <line x1="100" y1="30" x2="260" y2="70"/><line x1="260" y1="70" x2="420" y2="25"/>
          <line x1="420" y1="25" x2="580" y2="65"/><line x1="580" y1="65" x2="740" y2="35"/>
          <line x1="740" y1="35" x2="900" y2="72"/><line x1="900" y1="72" x2="1060" y2="28"/>
        </g>
      </svg>
      <div className="container-custom" style={{ paddingTop: 20, paddingBottom: 20, position: 'relative' }}>
        <div style={{ fontSize: 9, letterSpacing: '1.3px', textTransform: 'uppercase', color: '#5f7b8e', fontWeight: 700, marginBottom: 14 }}>Sponsored Content</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 32, flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 0', minWidth: 280 }}>
            <h2 style={{ fontFamily: SERIF, fontWeight: 500, fontSize: 28, lineHeight: 1.1, margin: '0 0 8px', color: '#fff' }}>Build the Future with Responsible AI</h2>
            <p style={{ fontSize: 13, color: '#8aa4b8', margin: 0 }}>Train your teams. Govern with confidence. Innovate at scale.</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <svg width="38" height="38" viewBox="0 0 44 44" fill="none" aria-hidden="true">
              <circle cx="22" cy="22" r="22" fill={TEAL}/>
              <path d="M14 26 Q14 18 22 18 Q22 13 28 14 Q34 12 34 20 Q37 20 37 24 Q37 28 33 28 L14 26Z" fill="#fff" opacity=".9"/>
            </svg>
            <div>
              <div style={{ color: '#fff', fontWeight: 700, fontSize: 18, letterSpacing: '-0.3px', lineHeight: 1 }}>CloudHub</div>
              <div style={{ color: '#7fafc0', fontSize: 11, letterSpacing: '0.3px' }}>AI Training &amp; Enablement</div>
            </div>
          </div>
          <Link to={SELF} style={{ background: TEAL, color: '#fff', padding: '12px 22px', borderRadius: 4, fontWeight: 700, fontSize: 14, textDecoration: 'none', whiteSpace: 'nowrap' }} data-testid="tai-sponsored-cta">
            Explore Solutions&nbsp;→
          </Link>
        </div>
      </div>
    </div>
  );
}

const TECHNOLOGY_AI_CONFIG = {
  slug: 'technology-ai',
  label: 'Technology & AI',
  selfPath: SELF,
  heroSlug: 'coverage/technology-ai',
  h1Text: 'Technology & AI',
  h1Subtitle: 'Powering innovation. Building talent. Shaping policy. Advancing startups. Expanding opportunity.',
  h1Body: 'Independent reporting and smart analysis on technology and AI trends, companies, policies, and people driving the future of work.',
  briefingCtaText: "Read Today's Tech Briefing",
  storiesCtaText: 'Explore Technology & AI Briefings',
  storiesAnchorId: 'sp-stories',
  gridLabel: 'Technology & AI Briefings',
  testId: 'technology-ai-page',
  rightRailWidgets: [
    { type: 'video_of_week', duration: '6:12', title: "AI's Next Frontier: From Models to Impact", description: 'How enterprises are moving beyond pilots to drive real-world results.' },
    { type: 'featured_company', badge: { text: 'AI', bg: '#0d1117', color: '#58a6ff' }, name: 'Anthropic', description: 'Building reliable, interpretable, and useful AI systems that augment human potential.' },
    { type: 'executive_spotlight', initials: 'AL', name: 'Alexandra Lee', title: 'Chief Technology Officer, Anthropic', description: "The future of AI is not just about intelligence — it's about alignment and impact." },
    { type: 'cta_pair' },
    { type: 'leaving_soon' },
    { type: 'first_round_promo' },
  ],
};

export default function TechnologyAIPage() {
  return (
    <SectorPage
      config={TECHNOLOGY_AI_CONFIG}
      PulseBar={() => <Ticker scope="technology-ai" />}
      SponsoredBand={SponsoredBand}
    />
  );
}
